import React from 'react';
import cx from 'classnames';
import { round } from 'lodash';
import { number, string, oneOf, bool } from 'prop-types';

import segmentStatus from 'propTypes/segmentStatus';
import TrendIcon from 'icons/trend.inline.svg';
import styles from './SpeedDisplay.scss';

export default function SpeedDisplay({ value, unit, status, trend, isHovered }) {
  return (
    <span className={cx(styles.main, { [styles[`status-${status}`]]: isHovered })}>
      {round(value, 1)}
      {unit &&
        <sup className={styles.unit}>
          {unit}
        </sup>}
      {trend &&
        <TrendIcon
          className={cx(styles.trend, {
            [styles[`trend-${trend}`]]: trend,
          })}
        />}
    </span>
  );
}

SpeedDisplay.defaultProps = {
  unit: 'mph',
};
SpeedDisplay.propTypes = {
  value: number.isRequired,
  unit: string,
  status: segmentStatus,
  isHovered: bool,
  trend: oneOf(['up', 'down']),
};



// WEBPACK FOOTER //
// ./src/components/SpeedDisplay/index.js